module.exports = __webpack_public_path__ + "img/base_restauration_glace.1bc8cd1c.svg";